import React, { ReactNode } from 'react';
import useTheme from '../hooks/ui/useTheme';
import CustomModal from '../components-library/CustomModal';
import { MODAL_SIZES } from '../services/exports/Constants';
import CloseIcon from '../assets/icons/actions/CloseIcon';

interface Props {
  title: string | ReactNode;
  description: string | ReactNode;
  footer?: ReactNode;
  openModal: boolean;
  /** Machine name for which alert this is — see AlertInfoInterface.marker. */
  marker?: string;
  toggleModal: () => void;
}

export default function AlertModal(props: Props) {
  const { title, description, footer, openModal, marker, toggleModal } = props;

  const theme = useTheme();

  return (
    // CustomModal returns null while closed, so the marker's PRESENCE is a valid open signal —
    // no separate data-open needed here.
    <CustomModal open={openModal} size={MODAL_SIZES.SM} onClose={toggleModal}>
      <div className={container} data-test="alert-modal" data-alert={marker}>
        <div onClick={toggleModal} className="cursor-pointer absolute right-lg" data-test="alert-modal-close">
          <CloseIcon className={closeIconStyle} color={theme?.color.brand.icon.color} />
        </div>
        <div className={wrapper}>
          {title && <h4 className={titleStyle}>{title}</h4>}
          {description && <p>{description}</p>}
          {footer && footer}
        </div>
      </div>
    </CustomModal>
  );
}

const container = 'w-full h-full p-lg flex flex-row justify-between relative';

const wrapper = 'w-full';

const titleStyle = 'mb-xs';

const closeIconStyle = 'h-4 w-4';
